// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iSJ-","colBig":"styles_colBig__2qSsY","colSmall":"styles_colSmall__qSnj7"};